

export class MapStatusInput implements IMapStatusInput {
    /** The auto-generated id of the map master */
    mapId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IMapStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MapStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new MapStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMapStatusInput {
    /** The auto-generated id of the map master */
    mapId: number;
    /** The updated status */
    status: number;
}

